import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import './Footer.css';
import styles from './Footer.module.css';

function LanguageSelect() {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(window.localStorage.getItem('i18nextLng') || 'en');

  function handleChange(event) {
    setLanguage(event.target.value);
  }

  useEffect(() => {
    i18n.changeLanguage(language);
    window.localStorage.setItem('i18nextLng', language);
  }, [language, i18n]);

  return (
    <select className={styles['hf--language-selector']} value={language} onChange={handleChange}>
      <option data-name="id" value="id">Bahasa Indonesia</option>
      <option data-name="id" value="de">Deutsch</option>
      <option data-name="id" value="en">English</option>
      <option data-name="id" value="es-es">Español</option>
      <option data-name="id" value="es-419">Español (Latinoamérica)</option>
      <option data-name="id" value="fr">Français</option>
      <option data-name="id" value="it">Italiano</option>
      <option data-name="id" value="pl">Polski</option>
      <option data-name="id" value="pt">Português</option>
      <option data-name="id" value="pt-br">Português (Brasil)</option>
      <option data-name="id" value="vi">Tiếng Việt</option>
      <option data-name="id" value="tr">Türkçe</option>
      <option data-name="id" value="ru">Русский</option>
      <option data-name="id" value="ar">العربية</option>
      <option data-name="id" value="ko">한국어</option>
    </select>
  );
}

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className={`${styles['ns--hf']} ${styles['sync-ui-footer']}`}>
      <div className={styles['hf--top-side']}>
        <div className={styles['hf--width-holder']}>
          <p className={styles['hf--back']}>
            <button className={`${styles['hf--text-uppercase']} ${styles['back-to-top']}`} type="button" onClick={() => {}}>{t('Top')}</button>
          </p>
        </div>
        <div className={styles['hf--social']}>
          <div className={styles['hf--width-holder']}>
            <p className={`${styles['hf--social-headline']} ${styles['hf--hide']}`}>{t('Follow us:')}</p>
            <div className={styles['hf--social-icons']}>
              <a className={styles.facebook} href="https://facebook.com/opera" data-event-action="hf-footer-social-item" data-event-category="hf">
                <span className={styles['hf--hide']}>{t('Facebook')}</span>
              </a>
              <a className={styles.twitter} href="https://twitter.com/opera" data-event-action="hf-footer-social-item" data-event-category="hf">
                <span className={styles['hf--hide']}>{t('Twitter')}</span>
              </a>
              <a className={styles.youtube} href="https://www.youtube.com/opera" data-event-action="hf-footer-social-item" data-event-category="hf">
                <span className={styles['hf--hide']}>{t('Youtube')}</span>
              </a>
              <a className={styles.linkedin} href="https://www.linkedin.com/company/opera-software" data-event-action="hf-footer-social-item" data-event-category="hf">
                <span className={styles['hf--hide']}>{t('LinkedIn')}</span>
              </a>
              <a className={styles.instagram} href="https://www.instagram.com/opera/" data-event-action="hf-footer-social-item" data-event-category="hf">
                <span className={styles['hf--hide']}>{t('Instagram')}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className={styles['hf--links']}>
        <div className={styles['hf--width-holder']}>
          <ul className={styles['hf--links-section']}>
            <li><strong className={styles['hf--text-uppercase']}>{t('Download Opera')}</strong></li>
            <li><a className={styles['hf--text-regular']} href="https://www.opera.com/computer">{t('Computer browsers')}</a></li>
            <li className={styles['hf--links-sep']}><a className={styles['hf--text-regular']} href="https://www.opera.com/mobile">{t('Mobile apps')}</a></li>
            <li><a className={styles['hf--text-regular']} href="https://dev.opera.com/">{t('Dev.Opera')}</a></li>
            <li><a className={styles['hf--text-regular']} href="https://www.opera.com/computer/beta">{t('Beta version')}</a></li>
          </ul>
          <ul className={styles['hf--links-section']}>
            <li><strong className={styles['hf--text-uppercase']}>{t('Services')}</strong></li>
            <li><a className={styles['hf--text-regular']} href="https://addons.opera.com">{t('Add-ons')}</a></li>
            <li><a className={`${styles['hf--text-regular']} ${styles['last-link']}`} href="https://auth.opera.com/account/login">{t('Opera account')}</a></li>
          </ul>
          <ul className={styles['hf--links-section']}>
            <li><strong className={styles['hf--text-uppercase']}>{t('Need help?')}</strong></li>
            <li><a className={styles['hf--text-regular']} href="https://www.opera.com/help">{t('Help & support')}</a></li>
            <li><a className={styles['hf--text-regular']} href="https://blogs.opera.com/">{t('Opera blogs')}</a></li>
            <li><a className={`${styles['hf--text-regular']} ${styles['last-link']}`} href="https://forums.opera.com">{t('Opera forums')}</a></li>
          </ul>
          <ul className={styles['hf--links-section']}>
            <li><strong className={styles['hf--text-uppercase']}>{t('Company')}</strong></li>
            <li><a className={styles['hf--text-regular']} href="https://www.opera.com/jobs">{t('Jobs')}</a></li>
            <li><a className={styles['hf--text-regular']} href="https://www.opera.com/b2b">{t('Become a partner')}</a></li>
            <li><a className={styles['hf--text-regular']} href="https://www.operasoftware.com/press">{t('Press info')}</a></li>
            <li><a className={styles['hf--text-regular']} href="https://www.operasoftware.com/company/contact">{t('Contact us')}</a></li>
            <li><a className={`${styles['hf--text-regular']} ${styles['last-link']}`} href="https://www.opera.com/about">{t('About Opera')}</a></li>
          </ul>
        </div>
      </div>
      <div className={`${styles['hf--bottom-side']} ${styles['hf--width-holder']}`}>
        <div className={styles['hf--bottom-wrapper']}>
          <div className={styles['hf--social']}>
            <p className={`${styles['hf--social-headline']} ${styles['hf--hide']}`}>{t('Follow us:')}</p>
            <div className={styles['hf--social-icons']}>
              <a className={styles.facebook} href="https://facebook.com/opera" data-event-action="hf-footer-social-item" data-event-category="hf">
                <span className={styles['hf--hide']}>{t('Facebook')}</span>
              </a>
              <a className={styles.twitter} href="https://twitter.com/opera" data-event-action="hf-footer-social-item" data-event-category="hf">
                <span className={styles['hf--hide']}>{t('Twitter')}</span>
              </a>
              <a className={styles.youtube} href="https://www.youtube.com/opera" data-event-action="hf-footer-social-item" data-event-category="hf">
                <span className={styles['hf--hide']}>{t('Youtube')}</span>
              </a>
              <a className={styles.linkedin} href="https://www.linkedin.com/company/opera-software" data-event-action="hf-footer-social-item" data-event-category="hf">
                <span className={styles['hf--hide']}>{t('LinkedIn')}</span>
              </a>
              <a className={styles.instagram} href="https://www.instagram.com/opera/" data-event-action="hf-footer-social-item" data-event-category="hf">
                <span className={styles['hf--hide']}>{t('Instagram')}</span>
              </a>
            </div>
          </div>
          <div className={styles['hf--copyrights']}>
            <ul className={styles['hf--copyrights-items']}>
              <li>
                <strong>
                  ©
                  {t('Opera Software')}
                </strong>
              </li>
              <li><a href="https://www.opera.com/privacy">{t('Privacy')}</a></li>
              <li><a href="https://www.opera.com/terms">{t('Terms of Use')}</a></li>
            </ul>
          </div>
          <div className={styles['hf--controls']}>
            <div className={styles['hf--language']}>
              <span className={styles['hf--language-selector-icon']}><span className={styles['hf--hide']}>{t('Select your language:')}</span></span>
              <span>
                <LanguageSelect />
              </span>
            </div>
            <div className={styles['hf--nav']}>
              <div className={styles['hf--width-holder']}>
                <p className={styles['hf--back']}>
                  <button className={`${styles['hf--text-uppercase']} ${styles['back-to-top']}`} type="button" onClick={() => {}}>{t('Top')}</button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
